import { render, staticRenderFns } from "./ValidacionExtendidaForm.vue?vue&type=template&id=ba294bb8&"
import script from "./ValidacionExtendidaForm.vue?vue&type=script&lang=ts&"
export * from "./ValidacionExtendidaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ba294bb8', component.options)
    } else {
      api.reload('ba294bb8', component.options)
    }
    module.hot.accept("./ValidacionExtendidaForm.vue?vue&type=template&id=ba294bb8&", function () {
      api.rerender('ba294bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/ValidacionExtendidaForm.vue"
export default component.exports